// Keeps the header cart badge (and anything else reading the "items"
// localStorage key) in sync within the same tab. Native localStorage
// writes don't fire the browser "storage" event in the tab that made
// the write, so components relying only on that event never see their
// own cart updates - only updates made in other tabs. This patches
// localStorage.setItem/removeItem once, at app startup, so every
// write to "items" (from any page, present or future) broadcasts a
// "cartUpdated" event that listeners can subscribe to.

const CART_KEY = 'items';
const CART_EVENT = 'cartUpdated';

export function initCartSync() {
  if (window.__cartSyncPatched) return;
  window.__cartSyncPatched = true;

  const nativeSetItem = localStorage.setItem.bind(localStorage);
  const nativeRemoveItem = localStorage.removeItem.bind(localStorage);
  const nativeClear = localStorage.clear.bind(localStorage);

  localStorage.setItem = (key, value) => {
    nativeSetItem(key, value);
    if (key === CART_KEY) {
      window.dispatchEvent(new Event(CART_EVENT));
    }
  };

  localStorage.removeItem = (key) => {
    nativeRemoveItem(key);
    if (key === CART_KEY) {
      window.dispatchEvent(new Event(CART_EVENT));
    }
  };

  localStorage.clear = () => {
    nativeClear();
    window.dispatchEvent(new Event(CART_EVENT));
  };
}

export function getCartItems() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch {
    return [];
  }
}

export function subscribeToCartChanges(callback) {
  window.addEventListener(CART_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(CART_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
}
